import React, { useState } from "react";
import { View } from "react-native";
import { TouchableOpacity } from "react-native";
import { Modal } from "react-native"
import DatePicker from "react-native-date-picker";
import { Text } from "../atoms";
import { useLanguage } from '@context';

export const TimepickerModal = ({isVisible, setIsVisible, onChange, value, fitParent = false}: {isVisible: boolean, setIsVisible: React.Dispatch<React.SetStateAction<boolean>>, onChange: (time: string) => void, value: string, fitParent?: boolean}) => {
  const { t } = useLanguage();
  const now = new Date();
  const [pickerTime, setPickerTime] = useState(value ? new Date(now.getFullYear(),
  now.getMonth(),
  now.getDate(),
  parseInt(value.split(':')[0]),
  parseInt(value.split(':')[1])) : now);
  
  return fitParent ? (isVisible ? (
    <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#5598D230', justifyContent: 'center', alignItems: 'center'}} 
      onStartShouldSetResponder={() => true}
      onResponderGrant={(evt) => {
        // Check if the touch is on the backdrop (not on modal content)
        if (evt.target === evt.currentTarget) {
          setIsVisible(false);
        }
      }
    }>
      <View style={{ backgroundColor: 'white', borderRadius: 16, padding: 16, width: 300, alignItems: 'center' }}>
        <Text type="bodyBold" style={{ marginBottom: 12 }}>{t('form.chooseTime')}</Text>
        <DatePicker
          date={pickerTime}
          onDateChange={setPickerTime}
          mode="time"
          locale="fr"
          is24hourSource="locale"
        />
        <View style={{ flexDirection: 'row', marginTop: 16 }}>
          <TouchableOpacity
            onPress={() => setIsVisible(false)}
            style={{ marginRight: 24 }}
          >
            <Text type="bodyBold">{t('common.cancel')}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              const h = pickerTime.getHours().toString().padStart(2, '0');
              const m = pickerTime.getMinutes().toString().padStart(2, '0');
              onChange(`${h}:${m}`);
              setIsVisible(false);
            }}
          >
            <Text type="bodyBold">{t('common.validate')}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  ) : <></>) : (
  <Modal
    visible={isVisible}
    transparent
    animationType="fade"
    onRequestClose={() => setIsVisible(false)}
  >
    <View style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignItems: 'center' }}>
      <View style={{ backgroundColor: 'white', borderRadius: 16, padding: 16, width: 300, alignItems: 'center' }}>
        <Text type="bodyBold" style={{ marginBottom: 12 }}>{t('form.chooseTime')}</Text>
        <DatePicker
          modal
          date={pickerTime}
          onDateChange={setPickerTime}
          mode="time"
          locale="fr"
          is24hourSource="locale"
        />
        <View style={{ flexDirection: 'row', marginTop: 16 }}>
          <TouchableOpacity
            onPress={() => setIsVisible(false)}
            style={{ marginRight: 24 }}
          >
            <Text type="bodyBold">{t('common.cancel')}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              const h = pickerTime.getHours().toString().padStart(2, '0');
              const m = pickerTime.getMinutes().toString().padStart(2, '0');
              onChange(`${h}:${m}`);
              setIsVisible(false);
            }}
          >
            <Text type="bodyBold">{t('common.validate')}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  </Modal>
  )
}

export default TimepickerModal